define('views/parts/form/select',[
    // Libs
    "underscore", "backbone", "mustache", "utils", "selectpicker",
    // services
    'services/i18n',
    // Templates
    "text!templates/parts/form/select.html"
], function(
    // Libs
    _, Backbone, Mustache, U, selectpicker,
    // services
    i18n,
    // templates
    TSelect
) {

    /**
     * Needs a collection to populate the select options.
     */
    var VSelect = Backbone.Epoxy.View.extend({
        template: TSelect,
        events: {
            'focus input': 'onInputFocus',
            'blur input': 'onInputBlur',
        },
        regions: {
            root: ".input-placeholder",
            label: ".control-label",
            input: ".form-control",
            select: ".selectpicker",
            error: ".error",
        },

        initialize: function(opt) {
            var options = this.options = _.extend({
                labelposition: "top",
                id: this.cid,
                filter: null,
                needsTranslatedLabel: true,
                validation: false,
                validationMsg: true,
            }, opt);

            this.options.config = this.options.config || {};

            options.option = _.extend({
                label: 'label',
                value: 'value',
                namespace: 'general'
            }, options.option);

            options.optgroup = _.extend({
                label: 'label',
                value: 'value'
            }, options.optgroup);

            var model = this.model;
            if (!model) {
                model = this.model = new Backbone.Model();
                model.set(options.attribute, null);
            }
        },

        initListeners: function() {
            var model = this.model,
                collection = this.collection;
            this.stopListeningTo(model);
            this.stopListeningTo(collection);

            this.listenTo(model,
                "change:" + this.options.attribute,
                this.onChange);

            if (this.options.validation) {
                this.listenTo(model, "invalid:" + this.options.attribute, this.onInvalid);
                if (this.options.validationMsg) {
                    this.regions.error = ".error";
                }
            }


            if (collection instanceof Backbone.Collection) {
                this.listenTo(collection, 'update', this.render);
            }
            return this;
        },

        render: function() {
            // Render Template HTML with Mustache
            this.$el.empty()
                .append(Mustache.render(
                    this.template,
                    Mustache.getContext(this.options)));

            this.applyBindings();

            this.generateZones()
                .addAll();

            // Change the select picker
            var noneSelectedText = this.options.noneSelectedText ? this.options.noneSelectedText : i18n.t('none-selected-text');
            this.zone.$select.selectpicker(_.extend(this.options.config, { noneSelectedText: noneSelectedText }));

            this.initListeners()
                .setValue(this.getValue());

            return this;
        },

        addAll: function() {
            var container = document.createDocumentFragment(),
                processFn = this.options.subgroup ? this.addSubGroup : this.addOne,
                collection = this.collection.models || this.collection;

            _.each(collection, function(model) {
                container.appendChild(processFn.call(this, model));
            }, this);

            this.zone.$select.empty().append(container);
            return this;
        },

        addSubGroup: function(model) {
            U.warn("VSelect.addSubGroup is unimplemented");
        },

        addOne: function(model) {
            var optionEl = document.createElement('option'),
                options = this.options.option,
                optValue = options.value,
                optLabel = options.label,
                text = model,
                value = model;
            if (model instanceof Backbone.Model) {
                text = model.get(optLabel);
                value = model.get(optValue);
            } else if (_.isObject(model)) {
                text = model[optLabel];
                value = model[optValue];
            }

            if (this.options.skipTranslation) {
              optionEl.text = text;
            }
            else {
              optionEl.text = i18n.t(text, { ns: this.options.option.namespace });
            }

            optionEl.value = value;

            return optionEl;
        },

        selectFirstOption: function() {
            var $select = this.zone.$select;
            $select.val(1);
            $select.selectpicker('refresh');
            this.setValue($select.val());
        },

        setValue: function(val, opt) {
            opt = opt || {};
            this.zone.$select.selectpicker('val', val);
            this.model.set(this.options.attribute, val, opt);
        },

        getValue: function() {
            return this.model.get(this.options.attribute);
        },

        getModelLabel: function() {
            var search = {};
            search[this.options.option.value] = this.getValue();
            var model = this.collection.findWhere(search);
            return model.get(this.options.option.label);
        },

        getLabel: function() {
            var model = this.collection.findWhere({ value: this.getValue() });
            return model.get('label');
        },

        setDisable: function(value) {
            this.zone.$select.prop('disabled', value).selectpicker('refresh');
        },

        clearError: function() {
            var zone = this.zone;
            if (zone) {
                zone.$root.removeClass("has-error");
                if (zone.$error) {
                    zone.$error.html("");
                }
            }
        },

        ////////////
        // events //
        ////////////
        onChange: function(model, value, options) {
            if (this.zone && this.zone.$select) {
                // refresh select
                this.setValue(value);
            }

            var params = [this.model, this.getValue()];
            _.callback(this.options.context, this.options.onChange, params);

            this.trigger.apply(this, ["change"].concat(params));
        },

        onInvalid: function (model, error, options) {
            var zone = this.zone;

            if (!zone) {
                return;
            }

            zone.$root.addClass("has-error");

            if (!this.options.validationMsg) {
                return;
            }

            var msg = this.options.validationMsg;

            if (typeof msg === "function") {
                msg = msg(model, error, options);
            } else if (typeof msg === "string") {
                msg = i18n.t(msg);
            } else {
                msg = i18n.t("general:" + error);
            }

            zone.$error.html(msg);
        },

        onDisable: function() {
            this.stopListeningTo(this.model);
            this.stopListeningTo(this.collection);
        }

    });

    return VSelect;

});

